import formStyles from '../formStyles.module.scss'
import styles from './textAreaInput.module.scss'

/**
 * Text area input field with a label
 */
const TextAreaInput = ({ id, name, title, placeholder = "", maxLength = 5000, onBlur, required = false, onChange, disabled, value }: {
    /**
     * string for input id
     */
    id: string,
    /**
     * string for input name
     */
    name: string,
    /**
     * string for title label text
     */
    title: string,
    /**
     * String for input placeholder text
     */
    placeholder?: string,
    /**
     * String for the max length of the text input field
     */
    maxLength?: number,
    /**
     * Boolean for requiring the field on submit
     */
    required?: boolean,
    /**
     * onChange function to be passed to component for form control.<br/>
     * onChange fires everytime something is changed in the input.
     */
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
    /**
     * onBlur function to be passed to component for form control.<br/>
     * onBlur fires every time the input loses focus. example of useage is to calculate a decimal once they finish typing and leave the box
     */
    onBlur?: React.ChangeEventHandler<HTMLTextAreaElement>,
    /**
     * disabled is a boolean attribute.
     * it specifies that the <input> element should be disabled.
     */
    disabled?: boolean,
    value?: string | number,

}) => {

    return (
        <div
            data-testid="textareainput"
            className={formStyles.inputcontainer}
        >
            <label
                data-testid="textinputlabel"
                htmlFor={id}
                className={`${formStyles.label} ${formStyles[id]}`}
            >
                {title}
            </label>
            <textarea
                autoComplete="off"
                value={value}
                onBlur={onBlur}
                onChange={onChange && onChange}
                data-testid="textinputinput"
                id={id}
                name={name}
                placeholder={placeholder}
                required={required}
                className={`${formStyles.input} ${styles.textAreaInput}`}
                maxLength={maxLength}
                disabled={disabled}
            />
        </div>
    )
}

export default TextAreaInput;